import * as kosik from "./kosik.js";
import * as doplnkoveSluzby from "../incl/doplnkove-sluzby.js";
import * as parametryDetailu from "../incl/parametry-detailu.js";
import { Shpt } from "../class/Shoptet.js";

import Vue from "vue";
import CenyBox from "../vue/CenyBox.vue";
import DoruceniBox from "../vue/DoruceniBox.vue";
import GalerieBox from "../vue/GalerieDetailu.vue";
import { Top } from "../class/Top.js";

//import { lcfirst } from "locutus/php/strings";

var detailProduktu = {
  Vyrobce: false,
  Product: false,
  BeznaCena: false,
  cenaBezDPH: false,
  maVarianty:false
};
var detailParametry = [];

export function vrat_ProductCode(){
  
  if(!detailProduktu.Product.hasVariants){
    return detailProduktu.Product.code;
  }
  return false;
}
export function jeMuProduct(){
  let code=vrat_ProductCode();
  if(!code)return false;
  if(code.substr(0,3)=='MU-')return true;

  return false; 

}

function det_ziskaniUdajuProduktu() {
  var $aVyrobce = $('.p-detail-info a[href^="/znacka/"]');
  detailProduktu.Vyrobce = false;
  if ($aVyrobce.length) {
    detailProduktu.Vyrobce = {
      url: $aVyrobce.attr("href"),
      text: $aVyrobce.text().trim()
    };
  }
  var $c = fce.get(window.dataLayer[0], "shoptet.product") || false;
  detailProduktu.Product = $c;

  let DL = window.getShoptetDataLayer("product") || false;
  if(DL){
    detailProduktu.maVarianty=DL.hasVariants;
  }


  $("form#product-detail-form").each(function() {
    let form = $(this);
    var c = form.find(".p-final-price-wrapper .price-standard");
    if (c.length) detailProduktu.BeznaCena = c.text().prevedNaCislo();

    c = form.find(".p-final-price-wrapper .price-additional");
    if (c.length) detailProduktu.cenaBezDPH = c.text().prevedNaCislo();
  });
} //function  det_ziskaniUdajuProduktu()

function vratVyrobce() {
  var $c = detailProduktu.Vyrobce;
  if (typeof $c == "undefined") return "";

  if (!$c) return "";

  var $v = window.vyrobce[$c.text];

  var $img = "";
  if (typeof $v == "undefined") {
    $img = "<strong>" + $c.text + "</strong>";
  } else {
    $img =
      '<img src="' +
      Top.shoptetUpload +
      window.ruzne.cesty.znacky +
      $v +
      '?v3">';
  }

  return (
    '<span class="vyrobce"><a href="' + $c.url + '">' + $img + "</a></span>"
  );
} //function vratVyrobce()

function det_nactiParametry() {
  var $tabulkaParametru = $("div#description table.detail-parameters");
  if (!$tabulkaParametru.length) return;

  $tabulkaParametru.find("tr").each(function() {
    /*
    var parametr = $(this)
      .find("th")
      .text()
      .trim()
      .slice(0, -1);
    if (parametr.substr(0, 2) == "? ") parametr = parametr.slice(2);
*/
    var a = $(this)
      .find("th .row-header-label")
      .clone();
    a.find(".show-tooltip").remove();
    a.find(".row-header-label-colon").remove();
    var parametr = a.text().trim();

    var hodnota = $(this)
      .find("td")
      .text()
      .trim();

    detailParametry[parametr] = hodnota;

    if (parametr.substr(0, 4) == "opt_") {
      $(this).remove();
    }
  });
} //function det_nactiParametry()

function f_detail_odstranZavorky() {
  $(".p-short-description")
    .not(':data("edit")')
    .html(function(i, t) {
      $(this).data("edit", true);
      //console.log('sss');
      return t.replace(/(\[|\])/g, "").replace(/\]/g, "</strong>");
    });

  //---odstraneni zavorek u filtrovacich paremetru

  $("#description table.detail-parameters th").html(function(i, t) {
    return t.replace(/\[([^\]]+)\] /g, "");
  });
} //function  f_detail_odstranZavorky()

function det_skladStav() {
  var $kod = "";

  var p = paramDetail("Stav zboží");
  Lc.log("Stav zboží", p);

  $kod += `<div class="leva">
  <div class="dostupnost"></div>
 </div><!-- class="leva"-->`;

  if (!p) return $kod;
  // ${det_stav(paramDetail("Stav zboží"))}
  $kod += `<div class="stred"> 
  ${det_stav(p)}
  </div><!-- class="stred"-->
  <div class="prava"></div>`;

  return $kod;
}

function det_30dnuHeureka() {
  var $kod = "";

  $kod += `<div class="leva">
    <span>Produkt nám můžeš<br>zdarma vrátit do 30 dnů</span>
   </div><!-- class="leva"-->`;

  $kod += `<div class="prava"> 
  <span>Z každého nákupu<br>budeš mít skvělý pocit </span>
      </div><!-- class="prava"-->`;

  return $kod;
} //function  det_30dnuHeureka()

function det_zobrazYoutubeVideo() {
  Lc.f("det_zobrazYoutubeVideo");

  var $c = paramDetail("opt_ytb");
  if (!$c) return false;
  Lc.log("youtube", $c);

  let kod = `  
<div id="dvYtb">
<h3>REALNÝ STAV | ZKOUKNI HO</h3>
<style>
.embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; } 
.embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }
</style>
<div class="embed-container">
<iframe src="${$c}" frameborder="0" allowfullscreen></iframe>
</div>
</div>
`;
  $(kod).appendTo(".p-image-wrapper");
} //function  det_youtubeVideo()
/*
function det_zobrazYoutubeVideo_old() {
  let p = false;
  if (!p) return false;
  var $c = paramDetail("opt_ytb");
  if (!$c) return false;

  var $div = $(".p-thumbnails-wrapper").addClass("dvMiniatury");
  $div.prepend(
    '<div><a id="aYoutube" href="#dvYoutubeModal" rel="modal:open"><img src="' +
      Top.shoptetUpload +
      '/detail/Video-5-icon.png"></a></div>'
  );
  //console.log('----youtube---video');

  var $iframe =
    '<style>.embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; } .embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }</style><div class="embed-container"><iframe src="' +
    $c +
    '" frameborder="0" allowfullscreen></iframe></div>';

  $("body").append(
    '<div id="dvYoutubeModal" class="modal">' + $iframe + "</form>"
  );
} //function  det_youtubeVideo()
*/
export function det_slevProZtp() {
  var $kupon = get(window.ruzne, "sleva.ztp.kod") || false;
  if (!$kupon) return false;

  var $minPrice = get(window.ruzne, "sleva.ztp.minPrice") || false;
  if (!$minPrice) return false;

  var $cena = get(window.ruzne, "sleva.ztp.cena") || false;
  if (!$cena) return false;

  var cena = fce.get(detailProduktu, "Product.priceWithVat") || 0;

  var $suma = kosik.kos_vratSumu() || 0;
  Lc.log("suma", $suma);
  Lc.log("cena", cena);
  if ($suma < $minPrice && cena < $minPrice) return false;
  //if (!$suma || ($suma < $minPrice && cena < $minPrice)) return false;

  var $kod = `<p> 
   <strong><em>DODATEČNÁ SLEVA ${$cena}</em> NA NÁKUP</strong> PRO DRŽITELE PRŮKAZU ZTP<br> 
   <small>*uplatníte ji jednoduše v dalším kroku objednávky</small> 
   </p>`;

  return $kod;
} //function  det_slevProZtp()

//--docasne skryto - nefungovalo to dobře
/*
function detail_upravVirtualniProhlidku() {
  var div = $("#dvObal .p-image-wrapper > div.image360");
  if (!div.length || div.find(".dvReal").length) return false;

  var nav = div.find(".image360-navigation");
  nav.prepend(
    '<div class="dvReal">PROHLÉDNĚTE SI REALNÝ STAV TOHOTO PRODUKTU</div>'
  );
  //nav.find(".icon-play").append("<small>PŘEHRÁT</small>");
  //nav.find(".icon-expand").append("<small>ZOOM</small><i>ZAVŘÍT</i>");
}
*/


function det_upravVarianty(){
  Lc.f('det_upravVarianty');
  if(!detailProduktu.maVarianty){
    return false;
  }

  let div = $('#dvVarianty');
  let varData = shoptet.variantsSplit.necessaryVariantData || false;

  
  div.find('table.detail-parameters tr.variant-list').each(function() {
    let tr = $(this);
    Lc.log('tr','neco');
    tr.find('th').wrapInner("<em></em>");


    
  });
  

  if(!varData){
    return false;
  }

}


function detail_upravStranku() {
  //--uprava hlavniho kontejneru
  var $form = $("#product-detail-form");
  $form.find(".p-image-wrapper").wrap("<div id='dvObal'></div>");
  $form.find(".p-info-wrapper").appendTo("#dvObal");

  det_galerie();

  $(".p-short-description").insertBefore(".p-final-price-wrapper");
  $(".p-detail-inner-header").insertBefore(".p-short-description");
  $(".p-detail-info").insertAfter(".p-detail-inner-header");
  $("a.chevron-after.chevron-down-after").insertAfter(".p-short-description");
  $(".link-icons.watchdog-active").insertAfter(
    ".extended-description table.detail-parameters"
  );
  $(".social-buttons-wrapper").insertAfter(".link-icons.watchdog-active");
  $(".flags.flags-default.flags-inline").insertAfter(".p-detail-info");
  //$( ".type-detail .p-info-wrapper .p-code" ).insertBefore( ".p-detail-inner-header" );
  //$(".type-detail .p-info-wrapper .p-code").prepend("<p>Kód produktu: &nbsp</p>");

  //virtualni prohlikda - spopsta problému
  //detail_upravVirtualniProhlidku();

  $form.find(".p-info-wrapper .p-code").each(function() {
    $(this).insertBefore(".p-detail-inner-header");
    $(this).prepend("<p>Kód produktu: &nbsp</p>");
    $(this).after(
      '<div id="dvNdp"><div class="flx"><div class="leva"></div><div id="dvZn"></div></div></div>'
    );
  });

  //pres
  $form
    .find(".p-detail-inner-header,.p-detail-info")
    .appendTo($("#dvNdp .leva"));

  //--znacka produktu
  $form
    .find('.p-detail-info a[href^="/znacka/"]')
    .closest("div")
    .remove();

  var $zn = vratVyrobce();
  if ($zn.length) $("#dvZn").append($zn);

  /*
  //--uprava tlacitka kosiku
  $(".p-final-price-wrapper").wrapInner("<div class='leva'></div>");
  $(".p-final-price-wrapper >.leva").wrapAll("<div class='flx'></div>");
  var $dvStred = $(
    "<div class='stred'><strong>Dostupnost zboží:</strong></div>"
  ).appendTo(".p-final-price-wrapper >.flx");
  var $dvPrava = $("<div class='prava'></div>").appendTo(
    ".p-final-price-wrapper >.flx"
  );
  $(".availability-value").appendTo($dvStred);
  $(".add-to-cart").appendTo($dvPrava);
  $(".add-to-cart .add-to-cart-button").html("<span>Přidat </span>do košíku");

  var $dvLeva = $(".p-final-price-wrapper .leva");

  //--produkt bez odectu DPH
  if (paramDetail("opt_dph") !== false && paramDetail("opt_dph") == "0") {
    $dvLeva.append('<span id="spnOdpDph"></span>');
    $dvLeva.find(".price-additional").remove();
  }

  $(".cofidis-wrap").appendTo($dvPrava);
*/

  //---------zpracovani pomoci VUE

  $('<div id="dvCenyBox"></div>').insertAfter(".p-short-description");
  Vue.config.productionTip = false;

  //$(".cofidis-wrap").appendTo("#dvCenyBox .dvTlacitko .prava");

  new Vue({
    render: h => h(CenyBox)
  }).$mount("#dvCenyBox");

 
  $("form#product-detail-form .add-to-cart").each(function() {
    let bt = $(this);
    bt.find('.add-to-cart-button').html('<span>Přidat </span>do košíku');
    bt.appendTo(
      "#dvCenyBox .spodek .prava .kosik"
    );
    
  });

  //---------/zpracovani pomoci VUE

  //predelane parametry
  $('<div id="dvParam"></div>').insertAfter(".p-detail-inner");

  //---prostor na doplnkove sluzby a varianty
  $('<div id="dvVarianty"></div><div id="dvDoplUpgrN" style="display:none"></div><div id="dvDoplUpgr"></div>').insertAfter(".p-short-description");

  //presun variant
  $('.p-info-wrapper > table.detail-parameters').appendTo('#dvVarianty');  
 det_upravVarianty();

  $(".show-tooltip").tooltip({
    html: true,
    placement: "auto"
  });

  var $fce = det_zobrazYoutubeVideo();
  /*
  $fce = det_slevProZtp();
  if ($fce.length)
    $('<div id="dvZtp">' + $fce + "</div>").insertAfter(
      ".p-final-price-wrapper"
    );
    */

  $fce = det_30dnuHeureka();
  if ($fce.length) {
    $(
      '<div id="dv30Heur"><div class="flx">' + $fce + "</div></div>"
    ).insertAfter(".p-final-price-wrapper");
  }

  $fce = det_skladStav();
  if ($fce.length) {
    $(
      '<div id="dvSkladStav"><div class="flx">' + $fce + "</div></div>"
    ).insertBefore("#dvCenyBox");

    $("form#product-detail-form .availability-value").appendTo(
      "#dvSkladStav .dostupnost"
    );

    $('a.shipping-options').appendTo(
      "#dvSkladStav .prava"
    );

    $(".aStav")
      .popover({
        animation: false,
        placement: "bottom",
        // trigger: 'click',
        html: true,
        delay: { show: 750, hide: 100 },
        container: $(this).attr("id"),
        content: function() {
          //$return = '<div class="hover-hovercard"></div>';
        }
      })
      .on("mouseenter", function() {
        var _this = this;
        $(this).popover("show");
        $(this)
          .siblings(".popover")
          .on("mouseleave", function() {
            $(_this).popover("hide");
          });
      })
      .on("mouseleave", function() {
        var _this = this;
        setTimeout(function() {
          if (!$(".popover:hover").length) {
            $(_this).popover("hide");
          }
        }, 100);
      });

    $(document).on("click", ".aPopoverVice", function() {
      //var $a = $(this);
      var $pop = $(this).closest(".popover");
      var $id = $pop.attr("id");

      var $aPuvod = $('a[aria-describedby="' + $id + '"]');
      $aPuvod.popover("hide");
      $aPuvod.modal();

      return event.preventDefault
        ? event.preventDefault()
        : (event.returnValue = false);
      //Alerts FileOne or FileTwo
    });
    //---box s dostupnosti apod
    $('<div id="dvDoruceniBox"></div>').insertAfter("#dvCenyBox");//#dvSkladStav
    new Vue({
      render: h => h(DoruceniBox)
    }).$mount("#dvDoruceniBox");
  }


  document.addEventListener("ShoptetSplitVariantParameterChange", function(
    e
  ) {
    let target = $(e.target);
    let nodeName = target.prop("nodeName");
    Lc.e('ShoptetSplitVariantParameterChange');
    Lc.log("nodeName", [target.prop("nodeName"),nodeName]);


    let sklad = shoptet.variantsSplit.necessaryVariantData;
    let id = Shpt.getSelectedParameters(target);

    let data = {
      test:true,
      id:id,
      sklad:sklad
    };

    $(document).trigger("ladzo:zmenenaVarianta", [data]);
  });  

  if(detailProduktu.maVarianty){
    Lc.h('vybrat prvni vyriantu');
     $('#dvVarianty .advanced-parameter-inner:first').trigger('click');
  }


} //function  detail_upravStranku()

function det_stav($stav) {
  //debugger;
  var $objekt = fce.get(window.sortimentDoplnky.STAVY, $stav) || false;

  var $tooltip = fce.get($objekt, "tooltip") || false;
  var $dataTooltip = "";
  if ($tooltip) {
    $tooltip +=
      '<br><a href="' + $objekt.url + '" class="aPopoverVice">více o stavu</a>'; //rel="modal:open"
    $dataTooltip = 'data-original-title="' + fce.escapeHtml($tooltip) + '"';
  }

  var tit1 = $objekt.title_1;
  var tit2 = $objekt.title_2 || false;

  var nazevOdkazu = tit2;
  var span = tit1 + " - ";
  if (!tit2) {
    nazevOdkazu = tit1;
    span = "";
  }
  Lc.log("obekt", $objekt);

  return (
    "<span>" +
    span +
    '</span> <a href="' +
    $objekt.url +
    '" rel="modal:open"  class="aStav" title="" ' +
    $dataTooltip +
    " >" +
    nazevOdkazu +
    "</a>"
  );
} //function  det_stav()

function det_upravaProExtras() {
  $("form#product-detail-form .add-to-cart").remove();
  $("form#product-detail-form .availability-label")
    .text("Samostatně neprodejné")
    .css("color", "red");
  $(".breadcrumbs-wrapper #navigation-1").remove();
} //function  det_upravaProExtras()

export function upravDeteailProduktu() {
  Lc.f("upravDetailProduktu");

  f_detail_odstranZavorky();

  det_ziskaniUdajuProduktu();
  det_nactiParametry();

  if (window.location.pathname.includes("/extras/")) {
    det_upravaProExtras();
  }

  detail_upravStranku();
  //--------docasne zakazano Ladzo.cz

  if (Top.zobrazNoveParametry) {
    parametryDetailu.parametryDetailuProduktu();
  }
  //doplnkove-sluzby.js
  doplnkoveSluzby.zpracujDoplnkoveSluzbyUpgrade();

  $("form#product-detail-form .add-to-cart-button").click(function() {
    doplnkoveSluzby.dopln_ulozitDoplnkyDoKosikuPrejitDoKosiku();
  });

  document.addEventListener("ShoptetCartAddCartItem", function() {
    /*
            console.log('%cclick listener','background:orange');
             console.log('orange');
             console.log($m);
             console.log($pp);


             return false;

             */

    if (!doplnkoveSluzby.opt.provestNakup) return false;
    if (!doplnkoveSluzby.opt.ajaxCartItem) return false;
    doplnkoveSluzby.opt.ajaxCartItem = false;

    //console.log('%ctoto by nemelo jit videt','background:black');

    window.showSpinner();
    var $cesta = false;
    var $vybraneDoplnky = doplnkoveSluzby.dopln_vratVybraneDoplnky();
    if ($vybraneDoplnky.length)
      doplnkoveSluzby.dopln_odeslatPolozkyAjaxem(
        $vybraneDoplnky,
        0,
        $vybraneDoplnky.length,
        $cesta
      );
  });
} //function  upravDeteailProduktu()

export function paramDetail($val) {
  var $c = detailParametry[$val];
  if (typeof $c == "undefined") return false;

  $c = $c.trim();
  var $return = $c;

  switch ($val) {
    case "opt_vymena":
    case "opt_predinstalace":
      $return = true;
      if ($c.toUpperCase() == "NE") $return = false;
      break;
    case "opt_ram":
    case "opt_disky":
    case "opt_zaruka":
    case "opt_upgrade_windows":
    case "opt_pridat_disk":
    case "opt_chlazeni":
    case "opt_zmenit_grafiku":
    case "opt_pridat_grafiku":
    case "opt_rgbkit":
    case "opt_bat":
      $return = $c.split(";").filter(Boolean);
      /* falls through */
      break;
  }

  return $return;
}



export function det_galerie() {
  

  
  if(detailProduktu.maVarianty){    
    return false;
  }
  $('#dvObal').addClass('skryjPuvGal');
  
  $('<div id="dvGalerie"></div>').prependTo(".p-image-wrapper");
  new Vue({
    render: h => h(GalerieBox)
  }).$mount("#dvGalerie");
  
}

export { detailProduktu, detailParametry };
